export default {
  暂无此对象查看权限: '暂无此对象查看权限',
  '删除后该数据将不再可见，是否确认？': '删除后该数据将不再可见，是否确认？',
  确定并添加下一条: '确定并添加下一条',
  确定并添加一条: '确定并添加一条',
  '关联记录单次新增数据条数最多100条！': '关联记录单次新增数据条数最多100条！'
};
